(() => {
  'use strict';
  const script = document.currentScript;
  if (!script || window.Shopify?.designMode) return;
  const article = document.querySelector('.article-template__content');
  if (!article || !/^\/blogs\/all-posts\/[^/]+\/?$/.test(location.pathname)) return;
  if (article.dataset.zenifyMeasurementBound === 'true') return;
  article.dataset.zenifyMeasurementBound = 'true';
  const mode = script.dataset.measurementMode === 'live' ? 'live' : 'preview';
  const allowed = () => {
    try {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
    } catch {
      return false;
    }
  };
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }
  const track = (event) => {
    if (!event.isTrusted || (event.type === 'auxclick' ? event.button !== 1 : event.button !== 0)) return;
    const link = event.target.closest?.('a[href]');
    if (!link || !article.contains(link) || link.hasAttribute('download')) return;
    let target;
    try { target = new URL(link.href, location.href); } catch { return; }
    if (target.origin !== location.origin || !/^\/(products|collections)\/[^/]+(?:\/products\/[^/]+)?\/?$/.test(target.pathname)) return;
    if (!allowed() || typeof window.gtag !== 'function') return;
    const markedId = link.getAttribute('data-zenify-cta');
    const id = markedId && /^[a-z0-9_-]{1,100}$/i.test(markedId)
      ? markedId : `article_link_${Array.from(article.querySelectorAll('a[href]')).indexOf(link) + 1}`;
    const params = {
      send_to: 'G-CF4YCNTK8B',
      blog_path: location.pathname,
      destination_path: target.pathname,
      cta_id: id,
      destination_type: target.pathname.startsWith('/collections/') ? 'collection' : 'product',
      measurement_mode: mode
    };
    if (mode === 'preview') params.debug_mode = true;
    window.gtag('event', 'blog_cta_click', params);
  };
  article.addEventListener('click', track, true);
  article.addEventListener('auxclick', track, true);
})();
